// Fraud analyzer -- a STUB, on purpose. It records what the analyzer will do and how it will be proven before it is allowed to stop anything. Nothing here
// scores an order, blocks a customer or calls the payment gateway.

const SIGNALS = [
  ["Product targeting", "The same product ordered by many unrelated new customers within a short window", "The July-August 2026 attack: 357 of 360 failed orders were one product"],
  ["Ticket size", "Order total far above the store's median order, first order from that customer", "Average attack order about $1,300 against a normal order near $100-$400"],
  ["Velocity", "New-customer orders or declines per hour, per day, per IP, per card BIN, per email domain", "2-4 attempts an hour, 353 different IPs"],
  ["Network and device", "Proxy or VPN, first time this IP or device is seen, IP used with several different billing details", "Proxy was flagged on only 113 of the 360 attack orders"],
  ["Address and card", "Billing, shipping and card-country mismatch; repeated AVS or CVV failures", "Needs Authorize.net transaction data (task #47)"],
  ["Account", "Guest checkout, time between account creation and order, free-mail domain on a large first order", "220 icloud.com and 139 gmail.com in the attack"],
];

export function FraudPanel() {
  return (
    <div>
      <h1>Fraud analyzer</h1>
      <p className="meta">
        <b>Stub: nothing is scored or blocked.</b> The plan is to replace the anti-fraud plugin with a console-owned analyzer that is asked before a payment is attempted.
        It has to be proven on the store's own history first, and it never blocks anything until it has run in shadow mode.
      </p>

      <h3>Stages</h3>
      <table className="manual-products">
        <thead><tr><th>Stage</th><th>What happens</th><th>Status</th></tr></thead>
        <tbody>
          <tr><td>1 Backtest</td><td>Run the rules over 10 years of orders. It must flag at least 357 of the 360 attack orders and none of the legitimate 2025-26 orders.</td><td>Not started: needs the orders loaded</td></tr>
          <tr><td>2 Shadow</td><td>Score every new order and attempt, record the verdict beside the plugin's, change nothing.</td><td>Not started</td></tr>
          <tr><td>3 Enforce</td><td>Allow, step up (CAPTCHA), hold for review or block, each logged and reversible, thresholds editable here.</td><td>Not started</td></tr>
        </tbody>
      </table>

      <h3 style={{ marginTop: 22 }}>Signals</h3>
      <table className="manual-products">
        <thead><tr><th>Signal</th><th>What it looks at</th><th>Evidence in the store's history</th></tr></thead>
        <tbody>{SIGNALS.map(([a, b, c]) => <tr key={a}><td>{a}</td><td className="wrap" style={{ whiteSpace: "normal" }}>{b}</td><td className="wrap" style={{ whiteSpace: "normal" }}>{c}</td></tr>)}</tbody>
      </table>

      <h3 style={{ marginTop: 22 }}>Why the current plugin is not enough</h3>
      <div className="panel" style={{ maxWidth: 760 }}>
        Its score for the attack orders ranged 15 to 95 (average 57) against 25 to 100 (average 89) for legitimate completed orders: the ranges overlap, so no single
        score threshold separates them. The attack was stopped by the card network's declines, not by the plugin.
      </div>
    </div>
  );
}
